import { render } from "./DemandForecastingSettings.vue?vue&type=template&id=22d4a4ea&scoped=true"
import script from "./DemandForecastingSettings.vue?vue&type=script&lang=js"
export * from "./DemandForecastingSettings.vue?vue&type=script&lang=js"

import "./DemandForecastingSettings.vue?vue&type=style&index=0&id=22d4a4ea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d4a4ea"]])

export default __exports__